import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useStaleOperationMonitor = () => {
  useEffect(() => {
    const checkStaleOperations = async () => {
      try {
        // Find operations with stale heartbeat (>10 min)
        const tenMinutesAgo = new Date(Date.now() - 10 * 60 * 1000).toISOString();
        
        const { data: staleOps } = await supabase
          .from('quiz_generation_operations')
          .select('*')
          .eq('status', 'in_progress')
          .lt('last_heartbeat', tenMinutesAgo);

        if (staleOps && staleOps.length > 0) {
          console.warn(`⚠️ Found ${staleOps.length} stale operations - triggering auto-recovery`);
          
          toast.warning(`⚠️ Stale operation detected - triggering auto-recovery`, {
            duration: 5000
          });
          
          // Trigger healer function
          const { error } = await supabase.functions.invoke('quiz-generation-healer');
          
          if (error) {
            console.error('Failed to trigger healer:', error);
          } else {
            console.log('✅ Auto-recovery triggered successfully');
          }
        }
      } catch (error) {
        console.error('Stale operation monitor error:', error);
      }
    };

    // Check every 5 minutes
    const interval = setInterval(checkStaleOperations, 5 * 60 * 1000);
    
    // Check immediately on mount
    checkStaleOperations();

    return () => clearInterval(interval);
  }, []);
};
